/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateCustomFieldDefinitionInput = {|
  id?: ?string,
  displayName?: ?string,
  readOnly?: ?boolean,
  avaRef?: ?number,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type updateCustomFieldDefinitionMutationVariables = {|
  input: UpdateCustomFieldDefinitionInput
|};
export type updateCustomFieldDefinitionMutationResponse = {|
  +updateCustomFieldDefinition: ?{|
    +customFieldDefinition: ?{|
      +node: ?{|
        +id: string,
        +key: ?string,
        +displayName: ?string,
        +readOnly: ?boolean,
        +entityType: ?string,
        +avaRef: ?number,
      |}
    |}
  |}
|};
export type updateCustomFieldDefinitionMutation = {|
  variables: updateCustomFieldDefinitionMutationVariables,
  response: updateCustomFieldDefinitionMutationResponse,
|};
*/


/*
mutation updateCustomFieldDefinitionMutation(
  $input: UpdateCustomFieldDefinitionInput!
) {
  updateCustomFieldDefinition(input: $input) {
    customFieldDefinition {
      node {
        id
        key
        displayName
        readOnly
        entityType
        avaRef
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCustomFieldDefinitionInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "updateCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDefinitionTypeEdge",
        "kind": "LinkedField",
        "name": "customFieldDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readOnly",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avaRef",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation updateCustomFieldDefinitionMutation(\n  $input: UpdateCustomFieldDefinitionInput!\n) {\n  updateCustomFieldDefinition(input: $input) {\n    customFieldDefinition {\n      node {\n        id\n        key\n        displayName\n        readOnly\n        entityType\n        avaRef\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '30e4be58224a2e561c104952d6fc13e7';

module.exports = node;
